export default "__VITE_ASSET__D19v68eR__"